import Vue from "vue";
//noinspection TypeScriptCheckImport
import Backend from "./Backend.vue";

Vue.config.devtools = true

const app = new Vue({
    el: "#ordercall-backend-app",
    template: `
    <backend/>
    `,
    components: {
        Backend,
    }
});



// WEBPACK FOOTER //
// ./src/webpack/vue/backend/index.ts